import { BaseService } from './base';
import { ServiceResource } from '../models/serviceResource';

/**
 * Stub service for ServiceResource model registration.
 * CRUD operations are managed through ServiceService
 * (addResource, updateResource, removeResource).
 */
export class ServiceResourceService extends BaseService<ServiceResource> {
  override model = ServiceResource;
  override modelName = 'serviceResource';
  override modelLabel = 'Service Resource';
}